"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const change_case_1 = require("change-case");
const camelCase_1 = __importDefault(require("lodash/camelCase"));
const kebabCase_1 = __importDefault(require("lodash/kebabCase"));
const lowerCase_1 = __importDefault(require("lodash/lowerCase"));
const lowerFirst_1 = __importDefault(require("lodash/lowerFirst"));
const startCase_1 = __importDefault(require("lodash/startCase"));
const upperCase_1 = __importDefault(require("lodash/upperCase"));
const upperFirst_1 = __importDefault(require("lodash/upperFirst"));
const addQuotes_1 = __importDefault(require("./addQuotes"));
const conditionalAdd_1 = require("./conditionalAdd");
const pluralization_1 = require("./pluralization");
/**
 * Helper functions that act like the `change-case` module
 */
const CASE_CONVERSIONS = {
    /**
     * Split by command and add quote around each word
     *
     * @param word - The word to change case of
     * @returns The word in csv string case
     */
    csvStringCase: (word) => word
        .split(',')
        .map((item) => (0, addQuotes_1.default)(item.trim()))
        .join(', '),
    /** Ensure ends with period and starts with capital */
    periodCase: (0, conditionalAdd_1.endsWith)('.', upperFirst_1.default),
    /** Used for regexes */
    regexCase: (0, conditionalAdd_1.endsWith)('_REGEX', change_case_1.constantCase),
    /** Used for selectors on frontend */
    selectorCase: (0, conditionalAdd_1.startsWith)('select', change_case_1.pascalCase),
    /** Used for frontend validators */
    validateCase: (0, conditionalAdd_1.startsWith)('VALIDATE_', change_case_1.constantCase),
    /**
     * Identity function
     *
     * @param word - The word
     * @returns The word
     */
    plainCase: (word) => word,
    // pluralize
    pluralCase: pluralization_1.pluralCase,
    singularCase: pluralization_1.singularCase,
    /**
     * Pascal and plural
     *
     * @param word - The word to change case of
     * @returns The word in pluralized in pascal case
     */
    pascalPluralCase: (word) => (0, change_case_1.pascalCase)((0, pluralization_1.pluralCase)(word)),
    // lodash
    lowerCase: lowerCase_1.default,
    paramCase: kebabCase_1.default,
    lowerFirst: lowerFirst_1.default,
    camelCase: camelCase_1.default,
    snakeCase: change_case_1.snakeCase,
    titleCase: startCase_1.default,
    upperCase: upperCase_1.default,
    upperFirst: upperFirst_1.default,
    kebabCase: kebabCase_1.default,
    // Change Case
    constantCase: change_case_1.constantCase,
    dotCase: change_case_1.dotCase,
    headerCase: change_case_1.headerCase,
    noCase: change_case_1.noCase,
    pascalCase: change_case_1.pascalCase,
    pathCase: change_case_1.pathCase,
    sentenceCase: change_case_1.sentenceCase,
    capitalCase: change_case_1.capitalCase,
};
exports.default = CASE_CONVERSIONS;
//# sourceMappingURL=cases.js.map